import router from "@/router";
class RouterService {
  redirectTo(name: string, paramName?: string, param?: any) {
    if (paramName) {
      return router.push({ name: name, params: { [paramName]: param } });
    } else {
      return router.push({ name: name });
    }
  }
}

export default new RouterService();
